import { DATA_TYPE_CODE } from '~/web-frontend-core/api/const/base';
import { BaseSocketConnector } from '~/web-frontend-core/api/connector/BaseSocketConnector';
export class ResultsLiveMenuListener extends BaseSocketConnector {
    constructor() {
        super(...arguments);
        this.dataTypeCode = DATA_TYPE_CODE.LIVE_RESULTS_FILTER;
    }
    getOutcomeData() {
        return {
            site: this.siteType,
            lng: this.language,
        };
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/api/connector/results/live/Menu.js